import { Connection } from "@zapier/client";

/** Direct members plus each team's member count; undefined when zero. */
export function getConnectionMemberCount(
  connection: Connection,
): number | undefined {
  const groupTotal = (connection?.groups ?? []).reduce(
    (sum, group) => sum + (group.memberCount ?? 0),
    0,
  );
  const memberTotal = connection?.members?.length ?? 0;
  const total = groupTotal + memberTotal;
  return total > 0 ? total : undefined;
}
